var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main-nav-bar',{staticClass:"position-sticky",on:{"search":function($event){return _vm.setSearchPhrase($event)}}}),_c('router-view',{attrs:{"model":_vm.searchPhrase}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }